import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from './../../common/dialog';

class OverageTable extends Component {
    static propTypes = {
        overageTable: PropTypes.array,
        hideOverageTable: PropTypes.func,
        handleUpdateOverageTable: PropTypes.func,
        isSavingOverageTable: PropTypes.bool,
        handleSaveOverageTable: PropTypes.func,
        handleAddOverageTable: PropTypes.func,
        handleDeleteOverageTable: PropTypes.func
    };

    renderData() {
        const { overageTable, handleUpdateOverageTable, handleDeleteOverageTable } = this.props;
        return overageTable.map((overage, index) => {
            return (
                <tr key={index}>
                    <td>
                        <input type="text" value={overage.start_quantity}
                            onChange={handleUpdateOverageTable.bind(this, index, 'start_quantity')} />
                    </td>
                    <td>
                        <input type="text" value={overage.finish_quantity}
                            onChange={handleUpdateOverageTable.bind(this, index, 'finish_quantity')} />
                    </td>
                    <td>
                        <input type="text" value={overage.overage}
                            onChange={handleUpdateOverageTable.bind(this, index, 'overage')} />
                    </td>
                    <td>
                        <div className="action-icon">
                            <i className="fas fa-trash" onClick={handleDeleteOverageTable.bind(this, index)} />
                        </div>
                    </td>
                </tr>
            );
        });
    }

    render() {
        const { hideOverageTable, handleSaveOverageTable, isSavingOverageTable, handleAddOverageTable, isFetchingElement } = this.props;

        let data = (
            <div>
                <table className="table table-sm table-striped data-table">
                    <thead>
                        <tr>
                            <th>Start Quantity</th>
                            <th>Finish Quantity</th>
                            <th>Overage</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>{this.renderData()}</tbody>
                </table>
                <div className="add-button" onClick={handleAddOverageTable} style={{ width: 120, fontSize: 13 }}><i className="fas fa-plus" /> Add Row</div>
            </div>
        );
        if (isFetchingElement) {
            data = <div className="loading-data"><i className="fas fa-circle-notch fa-spin" /> Loading data...</div>;
        }

        let saveButtonLabel = 'Save';
        if (isSavingOverageTable) {
            saveButtonLabel = <i className="fas fa-circle-notch fa-spin" />;
        }

        let actions = [
            <button key="save-button" className="btn btn-light btn-sm action-button"
                onClick={handleSaveOverageTable} disabled={isSavingOverageTable}>{saveButtonLabel}</button>,
            <button key="close-button" className="btn btn-light btn-sm action-button-cancel" onClick={hideOverageTable}>Close</button>
        ];
        return (
            <Dialog
                name="overage-table"
                modal={false}
                actions={actions}
                contentStyle={{ width: 800 }}
                bodyStyle={{ overflow: 'initial' }}
            >
                <div className="form-container">{data}</div>
            </Dialog>
        );
    }
}

export default OverageTable;
